import React from 'react'
import { getIconSize, setPropTypes } from './BaseIcon'

function ChevronRightIcon({ color, size, width, height }) {
  const finalSize = getIconSize({ size, width, height })
  return (
    <svg
      width={finalSize.width}
      height={finalSize.height}
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 15L8 8L1 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
setPropTypes(ChevronRightIcon)
export default ChevronRightIcon
